<footer adEl>
  <div adEl class="foot-in">
    <div adEl="footTop" class="foot-top">
      <div adEl class="foot-brand">
        <div adEl class="foot-logo">
          <apex-logo adEl></apex-logo>
        </div>
        <div adEl class="display">Apex Process Consultants</div>
        <p adEl>
          Process automation consulting and AI powered software development.
        </p>
      </div>
      <div adEl="practiceCol" class="foot-col">
        <h5 adEl>Practice</h5>
        <a adEl="consultingLink" routerLink="/consulting">Consulting</a>
        <a adEl="sprintLink" routerLink="/consulting">Envisioning Sprint</a>
        <a adEl="customLink" routerLink="/consulting">Custom Development</a>
      </div>
      <div adEl="platformCol" class="foot-col">
        <h5 adEl>Platform</h5>
        <a adEl="designerLink" href="https://apexdesigner.com" target="_blank"
          >Apex Designer ↗</a
        >
      </div>
      <div adEl="companyCol" class="foot-col">
        <h5 adEl>Company</h5>
        <a adEl="fieldNotesLink" routerLink="/field-notes">Field Notes</a>
        <a adEl="contactLink" routerLink="/contact">Contact</a>
        <a adEl="linkedinLink" href="https://www.linkedin.com" target="_blank"
          >LinkedIn ↗</a
        >
      </div>
    </div>
    <div adEl class="foot-bot">
      <span adEl>© 2026 Apex Process Consultants · Southfield, Michigan</span>
      <span adEl>Built on Apex Designer</span>
    </div>
  </div>
</footer>
